module.exports = {"150526100":"鲁北镇","150526101":"黄花山镇","150526102":"嘎亥图镇","150526103":"巨日合镇","150526104":"巴雅尔图胡硕镇","150526105":"香山镇","150526106":"阿日昆都楞镇","150526200":"巴彦塔拉苏木乡","150526201":"乌力吉木仁苏木乡","150526202":"道老杜苏木乡","150526203":"格日朝鲁苏木乡","150526204":"前德门苏木","150526205":"乌兰哈达苏木","150526206":"查布嘎图苏木","150526207":"乌额格其苏木","150526400":"乌额格其牧场","150526401":"香山农场","150526402":"乌日根塔拉农场","150526403":"嘎达苏种畜场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150526.json
// module id = 433
// module chunks = 0